// This component is generated by svgr. DO NOT EDIT.
import { SVGProps } from 'react'
type Props = {
  size?: 'sm' | 'md' | 'lg' | (string & {}),
} & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'color'>
const SvgFiletypePng = ({ size = 'md', ...props }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    height={
      size === 'sm'
        ? '8px'
        : size === 'md'
        ? '16px'
        : size === 'lg'
        ? '24px'
        : size
    }
    fill="none"
    viewBox="0 0 158 206"
    {...props}
  >
    <path
      fill="#999"
      d="M0 4a4 4 0 0 1 4-4h95.807c2.366 0 4.637.932 6.322 2.595l33.193 32.762A9 9 0 0 1 142 41.762V183a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M4 6a2 2 0 0 1 2-2h92a2 2 0 0 1 2 2v26.5c0 5.523 4.477 10 10 10h26a2 2 0 0 1 2 2V181a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"
    />
    <path
      fill="#999"
      d="M46.121 54.487H33.73v12.382H46.12zM58.522 66.87H46.13v12.382h12.392zM70.914 54.487H58.523v12.382h12.391zM83.306 66.87H70.914v12.382h12.392zM95.716 54.487H83.324v12.382h12.392zM108.108 66.87H95.716v12.382h12.392zM46.121 79.234H33.73v12.383H46.12zM58.522 91.617H46.13V104h12.392zM70.914 79.234H58.523v12.383h12.391zM83.306 91.617H70.914V104h12.392zM95.716 79.234H83.324v12.383h12.392zM108.108 91.617H95.716V104h12.392zM46.121 104.099H33.73v12.383H46.12zM58.522 116.482H46.13v12.383h12.392zM70.914 104.099H58.523v12.383h12.391zM83.306 116.482H70.914v12.383h12.392zM95.716 104.099H83.324v12.383h12.392zM108.108 116.482H95.716v12.383h12.392zM22 166a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v36a4 4 0 0 1-4 4H26a4 4 0 0 1-4-4z"
    />
    <path
      fill="#fff"
      d="M121.663 186.833h-1.349c-1.349 0-1.878.027-2.671.133v-3.994c.978.132 1.56.158 3.306.158h1.746c1.269 0 2.195-.026 3.28-.132-.133 1.005-.186 1.825-.186 3.439v2.883c0 1.719.027 2.486.186 3.65-1.746 1.058-2.778 1.507-4.285 1.904-1.27.344-2.83.556-4.232.556-3.412 0-6.163-1.111-7.935-3.174-1.614-1.931-2.54-4.92-2.54-8.173 0-4.497 1.852-8.068 5.079-9.84 1.481-.846 3.306-1.243 5.475-1.243 2.671 0 4.973.873 6.56 2.46.899.926 1.375 1.719 1.93 3.253l-4.47 1.111c-.423-1.217-.82-1.798-1.587-2.301-.74-.503-1.613-.714-2.856-.714-1.455 0-2.804.529-3.73 1.481-1.216 1.27-1.851 3.227-1.851 5.819 0 2.539.608 4.576 1.746 5.872.952 1.084 2.38 1.64 4.232 1.64 1.587 0 2.83-.318 4.152-1.085zM90.619 176.518l6.083 9.072c.608.9 1.243 1.958 1.799 3.016a45 45 0 0 1-.16-3.307v-8.014c0-1.719-.052-2.672-.237-3.809h4.734c-.158 1.111-.211 2.143-.211 3.835v13.992c0 1.561.053 2.698.211 3.677h-4.972c-.318-.714-.952-1.799-1.799-3.095l-6.083-9.046c-.53-.793-.979-1.587-1.693-2.962.026.317.026.317.106 1.243.026.45.079 1.561.079 2.09v7.723c0 1.799.053 3.015.212 4.047h-4.709c.16-.952.212-2.195.212-4.073v-13.754c0-1.455-.053-2.513-.212-3.677h4.92c.238.688.767 1.64 1.72 3.042M67.942 194.98h-4.76c.158-1.084.21-2.142.21-3.65v-14.31c0-1.349-.052-2.354-.21-3.623a71 71 0 0 0 3.623.079h5.634c2.671 0 4.629.661 5.951 1.984 1.11 1.111 1.72 2.777 1.72 4.761 0 2.116-.636 3.862-1.879 5.105-1.349 1.375-3.306 2.036-5.872 2.036h-4.628v3.915c0 1.508.053 2.645.211 3.703m-.211-11.347h4.523c2.142 0 3.359-1.19 3.359-3.28 0-.952-.265-1.746-.794-2.275-.555-.608-1.375-.872-2.565-.872H67.73zM54 190.404h4.576v4.576H54z"
    />
  </svg>
)
export default SvgFiletypePng
